import { render, staticRenderFns } from "./UsuariosChat.vue?vue&type=template&id=f736cf84&"
import script from "./UsuariosChat.vue?vue&type=script&lang=js&"
export * from "./UsuariosChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports